import { ComparePage } from '@/components/marketing/compare-page'

export function CompareConnectedPapersPage() {
  return (
    <ComparePage
      contentKey="compareConnectedPapers"
      path="/compare/connected-papers"
      otherLabel="Connected Papers"
      relatedKeys={['compareNotebooklm', 'whatIsKnowledgeGraph', 'useCasesResearchers']}
    />
  )
}
